import { ValidatorFn } from '@angular/forms';
import { CollectionDescription } from '../../models/collection-description.model';
import { AbstractFormControl } from '../abstract-form-control';

export class ComboBoxFormControl extends AbstractFormControl {
  constructor(
    required: boolean = false,
    disabled: boolean = false,
    private collectionDescription: CollectionDescription = {},
    private options?: ComboBoxOptions
  ) {
    super(required, disabled);

    if (
      collectionDescription &&
      collectionDescription.enableFirstChooseOption &&
      collectionDescription.collection.length
    ) {
      this.setValue(collectionDescription.collection[0][collectionDescription.keyPropertyName]);
    } else {
      this.setValue(null);
    }

    if (options && options.defaultValue) {
      this.setValue(options.defaultValue);
    }
  }

  public setCollection(collection: any[]) {
    this.collectionDescription.collection = collection;
  }

  public get collection(): any[] {
    return this.collectionDescription.collection;
  }

  public get keyPropertyName(): string {
    return this.collectionDescription.keyPropertyName;
  }

  public get valuePropertyName(): string {
    return this.collectionDescription.valuePropertyName;
  }

  get hideSuccessMark(): boolean {
    return this.options?.hideSuccessMark || false;
  }

  protected getValidators(): ValidatorFn[] {
    return [];
  }
}

export interface ComboBoxOptions {
  defaultValue?: any;
  hideSuccessMark?: boolean;
}
